import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <nav className="footer-nav">
            <ul className="footer-links">
              <li className="footer-item">
                <Link to="/" className="footer-link">Home</Link>
              </li>
              <li className="footer-item">
                <Link to="/upcoming-matches" className="footer-link">Upcoming</Link>
              </li>
              <li className="footer-item">
                <Link to="/completed-matches" className="footer-link">Results</Link>
              </li>
            </ul>
          </nav>

          <div className="copyright">
            &copy; {new Date().getFullYear()} JoltStats
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
